// extracted by mini-css-extract-plugin
module.exports = {"Page":"LocationList_Page__2yDyQ","FilterInput":"LocationList_FilterInput__3SVCd"};